import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../core/store';
import { 
    getFirstDayOfGivenMonth, 
    getFirstDayOfLastMonth, 
    getLastDayOfGivenMonth, 
    getLastDayOfLastMonth 
} from '../utils/downloadHelpers';

// Base selector to get the date range from state
const selectDateRange = (state: RootState) => state.defaultActivityDateRangeSlice.dateRangeData;

/**
 * Memoized selector that returns calculated date boundaries based on the current date range
 * Returns both first and last day of the given month or last month if no date range is set
 */
export const selectDateRangeBoundaries = createSelector(
    [selectDateRange],
    (dateRange) => {        
        
        const firstDayOfGivenMonthOrLastMonth = dateRange?.endDate
            ? getFirstDayOfGivenMonth(dateRange.endDate)
            : getFirstDayOfLastMonth();

        const lastDayOfGivenMonthOrLastMonth = dateRange?.endDate 
            ? getLastDayOfGivenMonth(dateRange.endDate) 
            : getLastDayOfLastMonth();
        
        return {
            firstDayOfGivenMonthOrLastMonth,
            lastDayOfGivenMonthOrLastMonth
        };
    }
);

export const selectDateRangeBoundariesForDailyAisSignals = createSelector(
    [selectDateRange],
    (dateRange) => {        
        const lastDateOfAisData = dateRange?.endDate ? new Date(dateRange.endDate) : new Date();
        lastDateOfAisData.setDate(lastDateOfAisData.getDate() + 1); // Add 1 day to get the last available daily data date

        const currentDate = new Date();
        
        return {
            lastDateOfAisData,
            currentDate
        };
    }
);
